import { defineStyleConfig } from "@chakra-ui/react";

/**
 * Sets default color for Heading component.
 */
export const Heading = defineStyleConfig({
  baseStyle: {
    color: "brand.500",
  },
  sizes: {
    md: {
      fontSize: "22px",
      fontWeight: "bold",
    },
  },
  defaultProps: {
    size: "md",
  },
});
